import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=121bcef8&scoped=true&"
import script from "./NewItem.vue?vue&type=script&lang=js&"
export * from "./NewItem.vue?vue&type=script&lang=js&"
import style0 from "./NewItem.vue?vue&type=style&index=0&id=121bcef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121bcef8",
  null
  
)

export default component.exports